import React from 'react';

import { Text } from 'ds';
import { formatUsd } from 'helpers';

interface PriceTagProps {
  amountCents: number;
  unitLabel?: string;
}

const PriceTag: React.FC<PriceTagProps> = ({ amountCents, unitLabel }) => {
  const formattedPrice = formatUsd(amountCents ? amountCents / 100 : 0, true);

  return (
    <Text size="body-sm" color="gray-400">
      {formattedPrice}
      {unitLabel && unitLabel}
    </Text>
  );
};

export default PriceTag;
